import { back } from "@/assets/images";
import { Button } from "@/components";
import { useDesignMaxTheme } from "@/packages/theme";
import { Box, Center, chakra, Modal as ChakraModal, ModalOverlay } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import { type CustomAnimateModalProps } from "./types";

export const AnimateModal = ({ onClose, isOpen, children }: CustomAnimateModalProps) => {
    const { MEDIAS } = useDesignMaxTheme();

    const { isLaptop, isMobile } = MEDIAS();
    const boxPCPaddingRight = isLaptop ? "88px" : "256px";

    const contentPCHeight = isLaptop ? "508px" : "792px";

    const handleClose = () => {
        setTimeout(onClose, 300);
    };

    return (
        <ChakraModal isOpen onClose={handleClose} closeOnOverlayClick={false}>
            <AnimatePresence>
                {isOpen && (
                    <MotionContainer
                        w="100%"
                        h="100vh"
                        zIndex="9998"
                        position="absolute"
                        top="0"
                        initial={{ x: "-100vw" }}
                        animate={{ x: 0, transition: { duration: 0.3, ease: "easeInOut" } }}
                        exit={{ x: "-100vw", transition: { duration: 0.3, ease: "easeInOut" } }}
                        onAnimationComplete={() => !isOpen && handleClose()}
                        sx={{
                            "& button": {
                                width: "40px",
                                h: "24px",
                                zIndex: "9999",
                                border: "none",
                                color: "white",
                                background: `url(${back})no-repeat center/cover`,
                            },
                        }}
                    >
                        <ModalOverlay />
                        <Box
                            position="absolute"
                            zIndex="9998"
                            w="100%"
                            h={isMobile ? "100%" : "auto"}
                            top="50%"
                            left="50%"
                            transform="translate(-50%,-50%)"
                            paddingRight={isMobile ? "0" : boxPCPaddingRight}
                            paddingTop={isMobile ? "64px" : "0"}
                            paddingBottom={isMobile ? "24px" : "0"}
                        >
                            <Box
                                position="relative"
                                w="100%"
                                height={isMobile ? "100%" : contentPCHeight}
                                background="white"
                                borderRightRadius="16px"
                                overflowY="scroll"
                                sx={{
                                    "& section": {},
                                }}
                            >
                                {children}
                            </Box>
                        </Box>
                        <Center position="absolute" w="100%">
                            <Center
                                top="0"
                                maxW="1600px"
                                w="100%"
                                h={isLaptop ? "60px" : "88px"}
                                paddingX="24px"
                                justifyContent="flex-end"
                            >
                                <Button onClick={onClose} />
                            </Center>
                        </Center>
                    </MotionContainer>
                )}
            </AnimatePresence>
        </ChakraModal>
    );
};

const MotionContainer = chakra(motion.div);
